
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 23 19","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('defs',[_c('path',{attrs:{"id":"a","d":"M6.444.149h10.111V18.85H6.444z"}})]),_c('clipPath',{attrs:{"id":"b"}},[_c('use',{attrs:{"xlink:href":"#a","overflow":"visible"}})]),_c('path',{attrs:{"clip-path":"url(#b)","fill":"#010101","d":"M16.175.153L13.749.149c-2.724 0-4.485 1.807-4.485 4.603v2.122H6.826a.382.382 0 00-.382.382v3.075c0 .21.171.381.382.381h2.438v7.758c0 .211.171.381.382.381h3.181a.38.38 0 00.382-.381v-7.758h2.851a.381.381 0 00.382-.381l.001-3.075a.387.387 0 00-.111-.271.384.384 0 00-.271-.111h-2.852V5.075c0-.865.206-1.304 1.332-1.304l1.634-.001a.381.381 0 00.382-.381V.535a.384.384 0 00-.382-.382"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      